import CustomersForm from '@/components/customers/CustomersForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';

export default function CustomersAddPage() {
  const navigate = useNavigate();

  return (
    <DefaultLayout
      header="Add Customer"
      breadcrumb={[
        { label: 'Customers', href: ROUTES.CUSTOMERS },
        { label: 'Add', isActive: true },
      ]}>
      <CustomersForm
        onSuccess={(uuid: string) => navigate(`${ROUTES.CUSTOMERS}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
